(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendation-2"] && !Shopify.designMode) return;
  try {
    
  function loadCustomProductRecommendations() {
  const customSection = document.querySelector('.custom-recommendations');
  if (!customSection) return;

  const { productId, limit, url } = customSection.dataset;

  fetch(`${url}?section_id=product-recommendations-custom&product_id=${productId}&limit=${limit}`)
    .then(res => {
      if (!res.ok) throw res;
      return res.text();
    })
    .then(html => {
      const div = document.createElement('div');
      const colClass = new Map([['2', 'half'], ['3', 'third'], ['4', 'quarter'], ['5', 'fifth']]);

      div.innerHTML = html;

      div.querySelectorAll('.prod-block').forEach(el => {
        el.classList.remove('half', 'third', 'quarter', 'fifth');
        el.classList.add(colClass.get(limit));
      });

      customSection.parentElement.innerHTML = div.querySelector('.custom-recommendations').innerHTML;

      if (window.theme?.initAnimateOnScroll) window.theme.initAnimateOnScroll();
      window.dispatchEvent(new CustomEvent('checkcaptionheights'));

      if (window.SPR?.initDomEls && window.SPR?.loadBadges) {
        SPR.initDomEls();
        SPR.loadBadges();
      }
    })
    .catch(err => console.error('Error loading custom recommendations:', err));
}

document.addEventListener('DOMContentLoaded', loadCustomProductRecommendations);

document.addEventListener('shopify:section:load', (e) => {
  if (e.detail.sectionId === 'product-recommendations-custom') {
    loadCustomProductRecommendations();
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function loadProductRecommendations() {
    const sprSection = document.querySelector('.product-recommendations');
    const { productId, limit, url } = sprSection.dataset;
    if (!sprSection) return;
    
    fetch(url + '?section_id=product-recommendations&product_id=' + productId + '&limit=' + limit)
      .then((response) => {
        if (!response.ok) { throw response };
        return response.text();
      })
      .then((html) => {
        const div = document.createElement('div');
        const colClass = new Map([['2', 'half'], ['3', 'third'], ['4', 'quarter'], ['5', 'fifth']]);

        div.innerHTML = html;
        div.querySelectorAll('.prod-block').forEach((el) => {
          el.classList.remove('half', 'third', 'quarter', 'fifth');
          el.classList.add(colClass.get(limit));
        });
        sprSection.parentElement.innerHTML = div.querySelector('.product-recommendations').innerHTML;

        window.theme.initAnimateOnScroll();
        window.dispatchEvent(new CustomEvent('checkcaptionheights'));

        // Shopify reviews app
        if (window.SPR && SPR.initDomEls && SPR.loadBadges) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'product-recommendations') {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
